import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=083ad28e&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=083ad28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ad28e",
  null
  
)

export default component.exports